import { Box, Flex, IconButton, Stack } from '@chakra-ui/react'
import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { faMegaphone } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { SUMMER_CAMP_COLORS } from '@/client/services/summerCamp/constants'

import { navBannerHeightDesktop, navBannerHeightMobile } from '@/components/Layout/Navbar/styled'
import RichText from '@/components/UI/RichTextEditor/RichText'

import type { NavbarBannerType } from '../types'

const COLOR_SCHEME_TO_COLORS = {
  purple: {
    bgColor: 'purple.solid',
    color: 'purple.contrast',
    dismissHoverBgColor: 'purple.fg',
    megaphoneColor: 'purple.fg',
  },
  yellow: {
    bgColor: 'yellow.emphasized',
    color: 'yellow.contrast',
    dismissHoverBgColor: 'yellow.fg',
    megaphoneColor: 'yellow.fg',
  },
  blue: {
    bgColor: 'blue.muted',
    color: 'fg',
    dismissHoverBgColor: 'blue.solid',
    megaphoneColor: 'blue.fg',
  },
  cyan: {
    bgColor: 'cyan.solid',
    color: 'cyan.contrast',
    dismissHoverBgColor: 'cyan.fg',
    megaphoneColor: 'cyan.muted',
  },
  summerCamp: {
    bgColor: SUMMER_CAMP_COLORS.primaryColor,
    color: 'white',
    dismissHoverBgColor: SUMMER_CAMP_COLORS.darkColor,
    megaphoneColor: SUMMER_CAMP_COLORS.lightColor,
  },
}

export default function BannerComponent({
  banner,
  onDismiss,
}: {
  banner: NavbarBannerType
  onDismiss: (() => Promise<void>) | (() => void)
}): React.ReactElement | null {
  const { bgColor, color, dismissHoverBgColor, megaphoneColor } =
    COLOR_SCHEME_TO_COLORS[('colorScheme' in banner ? banner.colorScheme : null) ?? 'yellow']
  return (
    <Flex
      height={{ base: navBannerHeightMobile, sm: navBannerHeightDesktop }}
      px={{ base: '12px', sm: '24px' }}
      direction="row"
      align="center"
      bgColor={bgColor}
      color={color}
      // Text is centered, until forced to multiple lines then let-align
      justify="space-between"
      textAlign="left"
      padding="16px"
    >
      <Box />
      <Stack direction="row" spacing={4} align="center" mr={6}>
        {banner.icon === 'megaphone' ? (
          <FontAwesomeIcon
            fontSize="16px"
            icon={faMegaphone}
            color={chakraTokenToVar(megaphoneColor)}
          />
        ) : null}
        {'children' in banner ? banner.children : <RichText content={banner.content} />}
      </Stack>
      {!banner.sticky ? (
        <IconButton
          _hover={{
            backgroundColor: dismissHoverBgColor,
            cursor: 'pointer',
          }}
          aria-label="Dismiss"
          icon={<FontAwesomeIcon icon={faTimes} />}
          variant="unstyled"
          onClick={onDismiss}
          width={8}
          height={8}
          py="3px"
          px="7px"
          m={0}
          minWidth={0}
        />
      ) : (
        <Box />
      )}
    </Flex>
  )
}
